import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Header from "../../../component/Header";
import {
  fetchAllForms,
  fetchCarriers,
  // COMMENTED OUT: fetchPolicies not used after OR section removal
  // fetchPolicies,
} from "../../../redux/Actions";
import { changeActiveHeader } from "../../../redux/Reducers/GeneralReducer";
import { usePagination } from "../../../hooks/usePagination";
import { strings, paths } from "../../../utils/constants";
import { Toast } from "../../../component/Toast";
import "./style.css";
import POPUP from "../../../component/Library_Popup";
import { handleShowPopup } from "../../../redux/Reducers/FormMangmentReducer";


const SearchForm = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { carrier, allForms, formList, showPopup } = useSelector(
    (state) => state.formMangmentReducer
  );
  // COMMENTED OUT: policy not used after OR section removal
  // const { policy } = useSelector((state) => state.formMangmentReducer);

  const { language } = useSelector((state) => state.generalReducer);

  const [page, setPage] = useState(1);
  const [isAda, setIsAda] = useState("all");
  const [carrierID, setCarrierID] = useState(strings.general.SELECT_CARRIER);
  // COMMENTED OUT: policyID state kept for compatibility but not used in UI after OR section removal
  const [policyID, setPolicyID] = useState("");

  const [carrierIdForFilter, setCarrierIdForFilter] = useState(
    strings.general.SELECT_CARRIER
  );

  // COMMENTED OUT: ADACarrierForFilter state kept for compatibility but not used in UI after OR section removal
  const [ADACarrierForFilter, setADACarrierForFilter] = useState("");

  const [search, setSearch] = useState("");
  const [searchForFilter, setSearchForFilter] = useState("");
  const [asc, setAsc] = useState("asc");
  const [isSearched, setIsSearched] = useState(false);
  // COMMENTED OUT: Popup state not used after OR section removal
  // const [Popup, setPopup] = useState(false);
  const listOfCarrier = async () => {
    await dispatch(fetchCarriers({ language: language, isAdmin: false }));
  };
  // COMMENTED OUT: listofPolicy kept for compatibility but not used in UI after OR section removal
  const listofPolicy = async () => {
    // Empty function - policies not loaded after OR section removal
    // await dispatch(fetchPolicies({ language: language, isAdmin: false }));
  };

  useEffect(() => {
    dispatch(changeActiveHeader(strings.navigationHeader.user.LIBRARY));
    // listOfCarrier();
    // listofPolicy();
  }, []);

  useEffect(() => {
    resetHandler();
  }, [language]);

  const paginationRange = usePagination({
    currentPage: page,
    totalCount: allForms?.total || allForms?.data?.total,
    pageSize: 10,
    siblingCount: 2,
    isInAdmin: false,
  });

  // const getAPI = async (page = 1, value = isAda, order = asc) => {
  //   if (
  //     value === "all" &&
  //     carrierIdForFilter !== strings.general.SELECT_CARRIER &&
  //     carrierIdForFilter !== "" &&
  //     searchForFilter !== "" &&
  //     ADACarrierForFilter !== t(strings.translate.SELECT_INFO_TYPE) &&
  //     ADACarrierForFilter !== ""
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       carrier_id: carrierIdForFilter,
  //       search_key: searchForFilter,
  //       policy_service_id: ADACarrierForFilter,
  //       language: language,
  //     };
  //     setIsAda("all");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     value !== "all" &&
  //     carrierIdForFilter !== strings.general.SELECT_CARRIER &&
  //     carrierIdForFilter !== "" &&
  //     searchForFilter !== "" &&
  //     ADACarrierForFilter !== t(strings.translate.SELECT_INFO_TYPE) &&
  //     ADACarrierForFilter !== ""
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       carrier_id: carrierIdForFilter,
  //       search_key: searchForFilter,
  //       policy_service_id: ADACarrierForFilter,
  //       isADA: value === "ada" ? true : false,
  //       language: language,
  //     };
  //     setIsAda(value === "ada" ? "ada" : "notada");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     value !== "all" &&
  //     carrierIdForFilter !== strings.general.SELECT_CARRIER &&
  //     carrierIdForFilter !== "" &&
  //     searchForFilter !== "" &&
  //     (ADACarrierForFilter === t(strings.translate.SELECT_INFO_TYPE) || ADACarrierForFilter === "")
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       carrier_id: carrierIdForFilter,
  //       search_key: searchForFilter,
  //       isADA: value === "ada" ? true : false,
  //       language: language,
  //     };
  //     setIsAda(value === "ada" ? "ada" : "notada");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     value === "all" &&
  //     carrierIdForFilter !== strings.general.SELECT_CARRIER &&
  //     carrierIdForFilter !== "" &&
  //     searchForFilter !== "" &&
  //     (ADACarrierForFilter === t(strings.translate.SELECT_INFO_TYPE) || ADACarrierForFilter === "")
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       carrier_id: carrierIdForFilter,
  //       search_key: searchForFilter,
  //       language: language,
  //     };
  //     setIsAda("all");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     value !== "all" &&
  //     carrierIdForFilter !== strings.general.SELECT_CARRIER &&
  //     carrierIdForFilter !== "" &&
  //     searchForFilter === "" &&
  //     ADACarrierForFilter !== t(strings.translate.SELECT_INFO_TYPE) &&
  //     ADACarrierForFilter !== ""
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       carrier_id: carrierIdForFilter,
  //       policy_service_id: ADACarrierForFilter,
  //       isADA: value === "ada" ? true : false,
  //       language: language,
  //     };
  //     setIsAda(value === "ada" ? "ada" : "notada");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     value === "all" &&
  //     carrierIdForFilter !== strings.general.SELECT_CARRIER &&
  //     carrierIdForFilter !== "" &&
  //     searchForFilter === "" &&
  //     ADACarrierForFilter !== t(strings.translate.SELECT_INFO_TYPE) &&
  //     ADACarrierForFilter !== ""
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       carrier_id: carrierIdForFilter,
  //       policy_service_id: ADACarrierForFilter,
  //       language: language,
  //     };
  //     setIsAda("all");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     value !== "all" &&
  //     (carrierIdForFilter === strings.general.SELECT_CARRIER || carrierIdForFilter === "") &&
  //     searchForFilter !== "" &&
  //     ADACarrierForFilter !== t(strings.translate.SELECT_INFO_TYPE) &&
  //     ADACarrierForFilter !== ""
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       search_key: searchForFilter,
  //       policy_service_id: ADACarrierForFilter,
  //       isADA: value === "ada" ? true : false,
  //       language: language,
  //     };
  //     setIsAda(value === "ada" ? "ada" : "notada");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     value === "all" &&
  //    ( carrierIdForFilter === strings.general.SELECT_CARRIER || carrierIdForFilter === "") &&
  //     searchForFilter !== "" &&
  //     ADACarrierForFilter !== t(strings.translate.SELECT_INFO_TYPE) &&
  //     ADACarrierForFilter !== ""
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       search_key: searchForFilter,
  //       policy_service_id: ADACarrierForFilter,
  //       language: language,
  //     };
  //     setIsAda("all");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     (carrierIdForFilter === "" || carrierIdForFilter === strings.general.SELECT_CARRIER) &&
  //     searchForFilter !== "" &&
  //     (ADACarrierForFilter === t(strings.translate.SELECT_INFO_TYPE) || ADACarrierForFilter === "") &&
  //     value !== "all"
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       isADA: value === "ada" ? true : false,
  //       search_key: searchForFilter,
  //       language: language,
  //     };
  //     setIsAda(value === "ada" ? "ada" : "notada");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     (carrierIdForFilter === "" || carrierIdForFilter === strings.general.SELECT_CARRIER) &&
  //     searchForFilter !== "" &&
  //     (ADACarrierForFilter === t(strings.translate.SELECT_INFO_TYPE) || ADACarrierForFilter === "") &&
  //     value === "all"
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       search_key: searchForFilter,
  //       language: language,
  //     };
  //     setIsAda("all");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     carrierIdForFilter !== strings.general.SELECT_CARRIER &&
  //     carrierIdForFilter !== "" &&
  //     searchForFilter === "" &&
  //     (ADACarrierForFilter === t(strings.translate.SELECT_INFO_TYPE) || ADACarrierForFilter === "") &&
  //     value !== "all"
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       isADA: value === "ada" ? true : false,
  //       carrier_id: carrierIdForFilter,
  //       language: language,
  //     };
  //     setIsAda(value === "ada" ? "ada" : "notada");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (
  //     carrierIdForFilter !== strings.general.SELECT_CARRIER &&
  //     carrierIdForFilter !== "" &&
  //     searchForFilter === "" &&
  //     (ADACarrierForFilter === t(strings.translate.SELECT_INFO_TYPE) || ADACarrierForFilter === "") &&
  //     value === "all"
  //   ) {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       carrier_id: carrierIdForFilter,
  //       language: language,
  //     };
  //     setIsAda("all");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if ((carrierIdForFilter === "" || carrierIdForFilter === strings.general.SELECT_CARRIER) &&
  //     searchForFilter === "" &&
  //     ADACarrierForFilter !== "" &&
  //     ADACarrierForFilter !== t(strings.SELECT_INFO_TYPE)
  //     && value !== "all") {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       policy_service_id: ADACarrierForFilter,
  //       isADA: value === "ada" ? true : false,
  //       language: language,
  //     };
  //     setIsAda(value === "ada" ? "ada" : "notada");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if ((carrierIdForFilter === "" || carrierIdForFilter === strings.general.SELECT_CARRIER) &&
  //     searchForFilter === "" &&
  //     ADACarrierForFilter !== "" &&
  //     ADACarrierForFilter !== t(strings.SELECT_INFO_TYPE)
  //     && value === "all") {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       policy_service_id: ADACarrierForFilter,
  //       language: language,
  //     };
  //     setIsAda("all");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else if (isEmpty(value) || value === "all") {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       language: language,
  //     };
  //     setIsAda("all");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  //   else {
  //     let formsRequest = {
  //       page: page,
  //       limit: 10,
  //       order: order,
  //       isADA: value === "ada" ? true : false,
  //       language: language,
  //     };
  //     setIsAda(value === "ada" ? "ada" : "notada");
  //     await dispatch(fetchAllForms({ formsRequest }));
  //   }
  // };

  const getAPI = async (page = 1, value = isAda, order = "asc") => {
    console.log(value);
    let formsRequest = {
      page: page,
      limit: 10,
      order: order,
      carrier_id:
        carrierIdForFilter !== strings.general.SELECT_CARRIER &&
          carrierIdForFilter !== ""
          ? carrierIdForFilter
          : undefined,
      search_key: searchForFilter !== "" ? searchForFilter : undefined,
      policy_service_id:
        ADACarrierForFilter !== t(strings.translate.SELECT_INFO_TYPE) &&
          ADACarrierForFilter !== ""
          ? ADACarrierForFilter
          : undefined,
      language: language,
      isADA: value !== "all" ? (value === "ada" ? "true" : "false") : undefined,
    };

    if (value !== "all") {
      setIsAda(value === "ada" ? "ada" : "notada");
    } else {
      setIsAda("all");
    }

    await dispatch(fetchAllForms({ formsRequest }));
  };

  const pageClickHandler = async (item) => {
    getAPI(item, isAda);
    setPage(item);
  };

  const nextPage = async () => {
    if (page !== paginationRange[paginationRange.length - 1]) {
      getAPI(page + 1, isAda);
      setPage(page + 1);
    }
  };

  const prevPage = async () => {
    if (page !== 1) {
      getAPI(page - 1, isAda);
      setPage(page - 1);
    }
  };

  const filterHandler = async (value) => {
    setPage(1);
    getAPI(1, value);
  };

  const carrierChangeHandler = async () => {
    var selectedKey = document.getElementById("list").value;
    setCarrierID(
      selectedKey === strings.general.SELECT_CARRIER ? "" : selectedKey
    );
  };

  // COMMENTED OUT: policyChangeHandler not used after OR section removal
  // const policyChangeHandler = async () => {
  //   var selectedKey = document.getElementById("policylist").value;
  //   setPolicyID(
  //     selectedKey === strings.translate.ADA_CARRIER_WEBSITE ? "" : selectedKey
  //   );
  // };

  // const searchHandler = async () => {
  //   setPage(1);
  //   setCarrierIdForFilter(carrierID);
  //   setADACarrierForFilter(policyID)
  //   setSearchForFilter(search);
  //   setIsAda("all");
  //   setAsc("asc");
  //   if (
  //     search === "" &&
  //     (carrierID === strings.general.SELECT_CARRIER || carrierID === "") &&
  //     (policyID === t(strings.translate.SELECT_INFO_TYPE) || policyID === "")
  //   ) {
  //     setIsSearched(false);
  //     let formsRequest = {
  //       page: page,
  //       limit: 0,
  //       order: "asc",
  //       language: language,
  //     };
  //     dispatch(fetchAllForms({ formsRequest }));
  //     Toast({
  //       type: "error",
  //       title: strings.words.ERROR,
  //       message: t(strings.translate.SELECT_CARRIER_OR_ADD_FORM_NUMBER_MSG),
  //     });
  //   }
  //   else if (carrierID && search === "" && (policyID === t(strings.translate.SELECT_INFO_TYPE) || policyID === "")) {
  //     let formsRequest = {
  //       page: 1,
  //       limit: 10,
  //       order: "asc",
  //       carrier_id: carrierID,
  //       language: language,
  //     };
  //     await dispatch(fetchAllForms({ formsRequest }));
  //     setIsSearched(true);
  //   }
  //   else if (
  //     (carrierID === strings.general.SELECT_CARRIER || carrierID === "") &&
  //     search &&
  //     (policyID === t(strings.translate.SELECT_INFO_TYPE) || policyID === "")
  //   ) {
  //     let formsRequest = {
  //       page: 1,
  //       limit: 10,
  //       order: "asc",
  //       search_key: search,
  //       language: language,
  //     };
  //     await dispatch(fetchAllForms({ formsRequest }));
  //     setIsSearched(true);
  //   }
  //   else if ((carrierID === strings.general.SELECT_CARRIER || carrierID === "") && search === "" && policyID) {
  //     console.log("YES ME");

  //     let formsRequest = {
  //       page: 1,
  //       limit: 10,
  //       order: "asc",
  //       policy_service_id: policyID,
  //       language: language
  //     };
  //     await dispatch(fetchAllForms({ formsRequest }))
  //     setIsSearched(true)
  //   }
  //   else if (carrierID && search &&
  //     (policyID === t(strings.translate.SELECT_INFO_TYPE || policyID === ""))
  //   ) {
  //     let formsRequest = {
  //       page: 1,
  //       limit: 10,
  //       order: "asc",
  //       carrier_id: carrierID,
  //       search_key: search,
  //       language: language
  //     }
  //     await dispatch(fetchAllForms({ formsRequest }))
  //     setIsSearched(true)
  //   }
  //   else if (carrierID && search === "" && policyID) {
  //     let formsRequest = {
  //       page: 1,
  //       limit: 10,
  //       order: "asc",
  //       carrier_id: carrierID,
  //       policy_service_id: policyID,
  //       language: language
  //     }
  //     await dispatch(fetchAllForms({ formsRequest }))
  //     setIsSearched(true)
  //   }
  //   else if ((carrierID === strings.general.SELECT_CARRIER || carrierID === "") && search && policyID) {
  //     let formsRequest = {
  //       page: 1,
  //       limit: 10,
  //       order: "asc",
  //       search_key: search,
  //       policy_service_id: policyID,
  //       language: language
  //     }
  //     await dispatch(fetchAllForms({ formsRequest }))
  //     setIsSearched(true)
  //   }
  //   else if (search && carrierID && policyID) {
  //     let formsRequest = {
  //       page: 1,
  //       limit: 10,
  //       order: "asc",
  //       carrier_id: carrierID,
  //       search_key: search,
  //       policy_service_id: policyID,
  //       language: language,
  //     };
  //     await dispatch(fetchAllForms({ formsRequest }));
  //     setIsSearched(true);
  //   }
  //   else {
  //     console.log("ooo");

  //     let formsRequest = {
  //       page: 1,
  //       limit: 10,
  //       order: "asc",
  //       language: language,
  //     };
  //     await dispatch(fetchAllForms({ formsRequest }));
  //     setIsSearched(true);
  //   }
  // };

  const searchHandler = async () => {
    setPage(1);
    setCarrierIdForFilter(carrierID);
    // COMMENTED OUT: setADACarrierForFilter kept for compatibility but not used in UI after OR section removal
    setADACarrierForFilter("");
    setSearchForFilter(search);
    setIsAda("all");
    setAsc("asc");



    const carrier_id =
      carrierID !== strings.general.SELECT_CARRIER && carrierID !== ""
        ? carrierID
        : undefined;
    const policy_service_id =
      policyID !== t(strings.translate.SELECT_INFO_TYPE) && policyID !== ""
        ? policyID
        : undefined;
    const search_key = search !== "" ? search : undefined;

    const formsRequest = {
      page: 1,
      limit: 10,
      order: "asc",
      language: language,
      carrier_id,
      policy_service_id,
      search_key,
    };

    const cleanedFormsRequest = Object.fromEntries(
      Object.entries(formsRequest).filter(([, value]) => value !== undefined)
    );

    if (!search_key && !carrier_id && !policy_service_id) {
      // Show error without API call
      setIsSearched(false);
      Toast({
        type: "error",
        title: strings.words.ERROR,
        message: t(strings.translate.SELECT_CARRIER_OR_ADD_FORM_NUMBER_MSG),
      });
    } else {
      // Only call API when user has valid search criteria
      await dispatch(fetchAllForms({ formsRequest: cleanedFormsRequest }));
      setIsSearched(true);
    }
  };

  const resetHandler = () => {
    // Reset form state without making API call
    setCarrierID(strings.general.SELECT_CARRIER);
    setCarrierIdForFilter(strings.general.SELECT_CARRIER);
    // COMMENTED OUT: ADA and policy related resets kept for compatibility but not used in UI after OR section removal
    setADACarrierForFilter("");
    setPolicyID("");
    listOfCarrier();
    // COMMENTED OUT: listofPolicy call kept for compatibility but does nothing after OR section removal
    listofPolicy();
    setIsAda("all");
    setSearch("");
    setSearchForFilter("");
    setIsSearched(false);
    setAsc("asc");
    setPage(1);
  };

  const handleClosePopup = async () => {
    await resetHandler();
    await dispatch(handleShowPopup(false));
  };

  const sortingHandler = (type) => {
    setAsc(type);
    setPage(1);
    getAPI(1, isAda, type);
  };

  const formNumberKeywordChangeHandler = (e) => setSearch(e.target.value);

  return (
    <body>
      <div>
        <Header />
      </div>
      <div className="text-center bg-white px-3 pb-3">
        <h4 className="pt-3">
          <b>{t(strings.translate.LIBRARY_NEW_TEXT_DIV_TITLE)}</b>
        </h4>
        <span>{t(strings.translate.LIBRARY_NEW_TEXT_DIV_DESC1)}</span> <br />
        {/* COMMENTED OUT: Second description removed as per Form Search Simplification since OR section is removed */}
        {/* <span className="pb-5">
          {t(strings.translate.LIBRARY_TEXT_DESC2)}
        </span> */}
      </div>
      <section className="subplan-banner bg--primary py-4">
        <div className="container" style={{ maxWidth: "1900px" }}>
          <div className="row justify-content-center align-items-end g-3">
            <div className="col-lg-3">
              <label htmlFor="carrier" className="form-label mb-2 fw-bold text-white">
                {t(strings.words.CARRIER)}
              </label>
              <select
                className="form-select py-2"
                id="list"
                aria-label="Default select example"
                onChange={carrierChangeHandler}
              >
                <option selected>{t(strings.translate.SELECT_CARRIER)}</option>
                {carrier?.data
                  ?.filter(
                    (item) =>
                      item?.carrier_name?.toLowerCase() !== "generic forms" &&
                      item?.carrier_name_fr?.toLowerCase() !==
                      "formulaires génériques"
                  )
                  .map((item) => (
                    <option key={item.id} value={item.id}>
                      {language === strings.language.FR
                        ? item.carrier_name_fr
                        : item.carrier_name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-lg-3" id="formnumber">
              <label htmlFor="formNum" className="form-label mb-2 fw-bold text-white">
                {t(strings.translate.FORM_NUMBER_KEYWORD)}
              </label>
              <input
                type="text"
                value={search}
                onChange={formNumberKeywordChangeHandler}
                className="form-control py-2"
                id="formNum"
              />
            </div>

            <div className="col-lg-auto">
              <button
                onClick={searchHandler}
                className="btn btn--secondary text-uppercase py-2"
                style={{ marginRight: "10px", minWidth: "120px" }}
              >
                {t(strings.words.SEARCH)}
              </button>
              <button
                onClick={resetHandler}
                className="btn btn--gray text-uppercase py-2"
                style={{ minWidth: "120px" }}
              >
                {t(strings.words.RESET)}
              </button>
            </div>
          </div>

          <div className="row justify-content-center mt-3">
            <div className="col-12 text-center">
              <span className="text-white opacity-75 d-inline-block">
                {t(strings.translate.CAN_NOT_FIND)}
                <Link
                  className="fg-secondary text-decoration-none border-b-secondary ms-2"
                  to={paths.userRoutes.DEMO_TRAINING_LIBRARY}
                  target="_blank"
                >
                  {t(strings.translate.CLICK_HERE_FOR_HELP)}
                </Link>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="py-3 py-lg-5 search-form-sec">
        <div className="container py-4">
          {isSearched ? (
            <>
              {/* <div className="mb-4 text-end filter-dropdow-main">
                <Link
                  className="dropdown-toggle px-0 filter-dropdown"
                  id="filter"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src={"../../../../../assets/images/filter-icon.svg"}
                    width="34"
                    height="25"
                    alt="filter icon"
                  />
                </Link>
                <div
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="filter"
                >
                  <Link
                    onClick={filterHandler.bind(this, "all")}
                    className="dropdown-item"
                  >
                    {t(strings.translate.ALL_FORMS)}
                  </Link>
                  <Link
                    onClick={filterHandler.bind(this, "ada")}
                    className="dropdown-item"
                  >
                    {t(strings.translate.ADA_FORMS)}
                  </Link>
                  <Link
                    onClick={filterHandler.bind(this, "notada")}
                    className="dropdown-item"
                  >
                    {t(strings.translate.NON_ADA_FORMS)}
                  </Link>
                </div>
              </div> */}
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr className="align-middle">
                      <th className="align-middle text-start ps-4" scope="col" style={{ width: "15%" }}>
                        {t(strings.words.CARRIER)}
                      </th>
                      <th scope="col" style={{ width: "10%" }} className="text-start">{t(strings.words.NUMBER)}</th>
                      {/* <th scope="col"></th> */}
                      <th scope="col" style={{ width: "35%" }} className="text-start">{t(strings.translate.DOCUMENT_NAME)}</th>
                      <th scope="col" style={{ width: "30%" }} className="text-start">{t(strings.words.DESCRIPTION)}</th>
                      <th className="text-center pe-4" scope="col" style={{ width: "10%" }}>{t(strings.words.VIEW)}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formList.filter(
                      (form) =>
                        form?.carrier?.carrier_name?.toLowerCase() !== "generic forms" &&
                        form?.carrier?.carrier_name_fr?.toLowerCase() !== "formulaires génériques"
                    ).length > 0 ? (
                      formList
                        ?.filter(
                          (form) =>
                            form?.carrier?.carrier_name?.toLowerCase() !== "generic forms" &&
                            form?.carrier?.carrier_name_fr?.toLowerCase() !== "formulaires génériques"
                        )
                        .map((item, index) => (
                          <tr key={index} className="align-middle">
                            <td className="text-start ps-4">
                              {language === strings.language.FR
                                ? item?.carrier?.carrier_name_fr
                                : item?.carrier?.carrier_name}
                            </td>
                            <td className="text-start">{item.form_number}</td>
                            {/* <td className="pe-0">
                            {/* {item.isADA && (
                              <span className="secondary-badge text-white d-inline-block">
                                {strings.words.ADA}
                              </span>
                            )} 
                          </td> */}
                            <td className="text-start">{item.form_name}</td>
                            <td className="text-start">{item.form_description}</td>
                            <td className="text-center">
                              {/* EDITED */}
                              <Link
                                className="btn"
                                to={
                                  item.form_actual_url &&
                                    item.form_actual_url !== ""
                                    ? item.form_actual_url
                                    : item.form_url
                                }
                                target="_blank"
                              >
                                <img
                                  src="../../../../../assets/images/pdf-icon.svg"
                                  width="30"
                                  height="30"
                                  alt="pdf"
                                />
                              </Link>
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center fw-bold py-5">
                          {t(strings.translate.NO_RECORD_FOUND)}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {formList.length > 0 && paginationRange.length > 0 && (
                <div className="pagination d-flex justify-content-center justify-content-md-end mt-4">
                  <ul className="m-0 p-0 d-flex ">
                    <li>
                      <Link
                        onClick={prevPage}
                        title="previous"
                        className="bg-transparent prev"
                      >
                        <i className="fa fa-angle-left" aria-hidden="true"></i>
                      </Link>
                    </li>
                    {paginationRange?.map((item, index) => (
                      <li key={index}>
                        <Link
                          onClick={pageClickHandler.bind(this, item)}
                          title="2"
                          className={item === page ? "active" : ""}
                        >
                          {item}
                        </Link>
                      </li>
                    ))}
                    <li>
                      <Link
                        onClick={nextPage}
                        title="next"
                        className="bg-transparent next"
                      >
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </>
          ) : (
            <div className="container text-center">
              <img
                src={"../../../../../assets/images/search-form-bg.svg"}
                className="img-fluid rounded mx-auto d-block"
                alt="search-form-bg"
                style={{
                  maxWidth: "300px",
                  maxHeight: "300px",
                  height: "30vh",
                  width: "30vh",
                }}
              />
            </div>
          )}
        </div>
        {showPopup && (
          <POPUP isOpen={showPopup} closeHandler={handleClosePopup}></POPUP>
        )}
      </section>
    </body>
  );
};

export default SearchForm;
